import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const RefineRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  width: 100%;
`;

export const CancelButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  min-width: 2.75rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background: var(--color-white, #fff);
  box-shadow: var(--light-shadow);
  color: var(--color-charcoal, #212121);

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const InputShell = styled.div`
  flex: 1;
  min-width: 0;
  padding: 1.5px;
  border-radius: 1.6rem;
  background: #ffd199;
  box-shadow: var(--light-shadow);
`;

export const InputCard = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.3rem;
  min-height: 2.75rem;
  padding: 0.375rem 0.5rem 0.375rem 0.8125rem;
  border-radius: calc(1.6rem - 1.5px);
  background: var(--color-white, #fff);
`;

export const CorrectionInput = styled.textarea`
  flex: 1 1 0%;
  min-width: 0;
  min-height: 2rem;
  max-height: 8em;
  padding: 0.3rem 0;
  border: none;
  outline: none;
  resize: none;
  overflow-y: auto;
  background: transparent;
  font-family: inherit;
  font-size: 1rem;
  line-height: 1.4;
  letter-spacing: -0.02em;
  word-break: break-word;
  color: var(--color-charcoal, #212121);

  &::placeholder {
    color: var(--color-gray, #aaa7a0);
  }
`;

export const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background: var(--Accessible-Blue, #3973da);
  color: var(--color-white, #fff);

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }

  svg {
    width: 1rem;
    height: auto;
  }
`;

export const SubmitSpinner = styled.span`
  display: block;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: var(--color-white, #fff);
  animation: ${spin} 0.7s linear infinite;
`;
